(function () {
    'use strict';

    angular.module("imApp").factory("dispatchPlanningConsignmentService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1577,
                    parameters: parms || {}
                });
            },
            listCollis: function (parms) {
                return $ihttp.post({
                    method: 2233,
                    parameters: parms || {}
                });
            },
            listOrderLines: function (parms) {
                return $ihttp.post({
                    method: 2282,
                    parameters: parms || {}
                });
            },
            getReportSetting: function (parms) {
                return $ihttp.post({
                    method: 2255,
                    parameters: parms || {}
                });
            },
            createConsignment: function (setting) {
                return $ihttp.post({
                    method: 2270,
                    parameters: setting
                });
            },
            transferConsignment: function (setting) {
                return $ihttp.post({
                    method: 2283,
                    parameters: setting
                });
            },
            mergeCollis: function (list) {
                return $ihttp.post({
                    method: 2280,
                    parameters: list
                });
            },
            splitCollis: function (list) {
                return $ihttp.post({
                    method: 2281,
                    parameters: list
                });
            }
        };

        return service;
    }]);
})();
